import type { CanvasKind, DraftKind } from "./types";

export interface NodeDefinition {
  label: string;
  shortLabel: string;
  color: string;
  canCreate: boolean;
  derives: DraftKind[];
}

export const nodeRegistry: Record<CanvasKind, NodeDefinition> = {
  llm: {
    label: "LLM channel",
    shortLabel: "LLM",
    color: "#1769e0",
    canCreate: true,
    derives: ["model", "agent"]
  },
  mcp: {
    label: "MCP server",
    shortLabel: "MCP",
    color: "#14806d",
    canCreate: true,
    derives: ["agent"]
  },
  a2a: {
    label: "A2A endpoint",
    shortLabel: "A2A",
    color: "#8055a6",
    canCreate: true,
    derives: ["agent"]
  },
  model: {
    label: "Virtual model",
    shortLabel: "Model",
    color: "#0f7490",
    canCreate: true,
    derives: ["agent"]
  },
  agent: {
    label: "Agent profile",
    shortLabel: "Agent",
    color: "#c25c35",
    canCreate: true,
    derives: ["key", "task"]
  },
  key: {
    label: "Virtual key",
    shortLabel: "Key",
    color: "#9a6b10",
    canCreate: true,
    derives: []
  },
  task: {
    label: "Runtime task",
    shortLabel: "Task",
    color: "#28758f",
    canCreate: true,
    derives: []
  },
  discovery: {
    label: "Discovery candidate",
    shortLabel: "New",
    color: "#d8563a",
    canCreate: false,
    derives: []
  }
};

export const createKinds: DraftKind[] = ["llm", "mcp", "a2a", "model", "agent", "key", "task"];
